"use client"

import { useState } from "react"
import "./Resume.css"
import ResumeFile from './files/resume.pdf'

const Resume = () => {
  const [activeTab, setActiveTab] = useState("experience")

  return (
    <div className="resume-container">
      <div className="resume-header">
        <h1>My Resume</h1>
        <div className="resume-actions">
          <a className="download-btn" href={ResumeFile} download="Safwen_Resume.pdf">
            <i className="fas fa-download"></i> Download PDF
          </a>
        </div>
      </div>

      <div className="resume-tabs">
        <button
          className={`tab-btn ${activeTab === "experience" ? "active" : ""}`}
          onClick={() => setActiveTab("experience")}
        >
          Experience
        </button>
        <button
          className={`tab-btn ${activeTab === "education" ? "active" : ""}`}
          onClick={() => setActiveTab("education")}
        >
          Education
        </button>
        <button className={`tab-btn ${activeTab === "skills" ? "active" : ""}`} onClick={() => setActiveTab("skills")}>
          Skills
        </button>
      </div>

      <div className="resume-content">
        {activeTab === "experience" && (
          <div className="experience-section">
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-date">Jan 2023 - May 2023</div>
                <div className="timeline-content">
                  <h3>Software Developer Intern</h3>
                  <h4>RFC</h4>
                  <ul>
                    <li>Developed a complete Internet of Things (IoT) solution for personnel identification using Microsoft Azure cloud services and facial recognition.</li>
                    <li>Logged user access data into a secure database and designed a web-based admin dashboard for data management.</li>
                    <li>Emphasized secure authentication, real-time data handling, and cloud deployment.</li>
                  </ul>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-date">Jun 2022 - July 2022</div>
                <div className="timeline-content">
                  <h3>Software Developer Intern</h3>
                  <h4>Vermeg</h4>
                  <ul>
                    <li>Participated in a summer internship focused on backend development using Spring Boot.</li>
                    <li>Built core functionalities for a workspace reservation system used internally by employees.</li>
                    <li>Gained practical experience with RESTful APIs, data handling, and enterprise-level backend development.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "education" && (
          <div className="education-section">
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-date">2024 - PRESENT</div>
                <div className="timeline-content">
                  <h3>Master of Science in Software Engineering</h3>
                  <h4>Universiti Teknologi Malaysia, Kuala Lumpur</h4>
                  <p>
                    Focus on advanced software architecture, system design, and development methodologies.
                  </p>
                  <div className="highlights">
                    <span>GPA: 4.0/4.0</span>
                  </div>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-dot"></div>
                <div className="timeline-date">2010 - 2012</div>
                <div className="timeline-content">
                  <h3>Bachelor Degree in Computer Engineering</h3>
                  <h4>Higher Institute of Information and Communication Technologies</h4>
                  <p>
                    Specialized in networking and computer systems.
                  </p>
                  <div className="highlights">
                    <span>GPA: 2.7/4.0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "skills" && (
          <div className="skills-section">
            <div className="skills-category">
              <h3>Programming Languages</h3>
              <div className="skills-grid">
                <div className="skill-item">
                  <div className="skill-name">JavaScript</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "95%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Java</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "89%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">C</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "70%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">HTML5</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "90%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">CSS3</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "85%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Python</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "75%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">PHP</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "70%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Lua</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "70%" }}></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="skills-category">
              <h3>Frameworks & Libraries</h3>
              <div className="skills-grid">
                <div className="skill-item">
                  <div className="skill-name">React</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "90%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Express</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "80%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Django</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "75%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Node.js</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "85%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Laravel</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "80%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Flask</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "75%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Spring Boot</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "66%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">FastAPI</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "70%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Axios</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "90%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">jQuery</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "80%" }}></div>
                  </div>
                </div>
                <div className="skill-item">
                  <div className="skill-name">Ajax</div>
                  <div className="skill-bar">
                    <div className="skill-level" style={{ width: "70%" }}></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="skills-category">
              <h3>Tools & Technologies</h3>
              <div className="skills-tags">
                <span>Git</span>
                <span>Docker</span>
                <span>Microsoft Azure</span>
                <span>Azure IoT</span>
                <span>OpenCV</span>
                <span>MySQL</span>
                <span>PostgreSQL</span>
                <span>Oracle SQL</span>
                <span>REST APIs</span>
                <span>Postman</span>
                <span>CI/CD</span>
                <span>Agile/Scrum</span>
                <span>Team Management</span>
                <span>Leadership</span>
                <span>Communication</span>
                <span>Problem Solving</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Resume
